var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aboutMethodologies_x5F_SVG",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    enableBackground: "new 0 0 17 17",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M12.244,7.531H4.761L4.726,7.516l-1.18-1.18L3.531,6.3V2.746L3.546,2.71l1.147-1.146l0.035-0.015h7.549 l0.035,0.015l1.146,1.146l0.015,0.035V6.3l-0.015,0.036l-1.181,1.18L12.244,7.531z M4.781,7.43h7.442l1.149-1.15V2.767 L12.256,1.65H4.748L3.631,2.767V6.28L4.781,7.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M11.451,6.909H5.553L5.518,6.894l-0.93-0.93L4.573,5.928V3.126L4.588,3.09l0.904-0.904l0.035-0.015h5.952 l0.035,0.015l0.901,0.904l0.017,0.036v2.802l-0.017,0.036l-0.931,0.93L11.451,6.909z M5.574,6.808h5.857l0.899-0.9V3.147 l-0.875-0.875H5.548L4.674,3.147v2.761L5.574,6.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M4.761,7.531L4.74,7.526L4.711,7.485L4.637,6.652l-1.07-0.303l-0.034-0.06l0.493-2.024L3.533,2.761 l0.004-0.039l0.031-0.024l0.899-0.242L4.68,1.587l0.031-0.035L4.759,1.56l0.799,0.622l0.019,0.05L5.54,2.27L4.551,2.537 L4.13,4.262l0.541,1.651l0.06,0.66L5.566,6.81l0.035,0.039L5.584,6.898L4.791,7.52L4.761,7.531z M4.739,6.68l0.063,0.704 l0.643-0.505L4.739,6.68z M3.641,6.266l0.986,0.278L4.573,5.933L4.086,4.445L3.641,6.266z M3.645,2.781L4.07,4.082l0.371-1.516 L3.645,2.781z M4.758,1.687l-0.18,0.738L5.417,2.2L4.758,1.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M4.761,7.531L4.713,7.498l0.031-0.064l1.744-0.619L6.51,6.812l5.689,0.613l0.035-0.407l-0.789-0.11 l-0.043-0.057l0.057-0.042l0.785,0.109l0.088-0.994l0.023-0.038l0.043-0.005l0.403,0.145l0.166-0.951l-0.635-1.934V3.113 l0.149-0.567l-1.02-0.275L11.426,2.22l0.041-0.047l1.203-0.212l0.045,0.016l0.012,0.047l-0.121,0.451l0.83,0.224l0.035,0.057 l-0.4,2.311l0.4,1.219l-0.013,0.051l-0.054,0.012L12.88,6.161l-0.151,0.877L12.68,7.08l-0.008-0.001l-0.338-0.047l-0.041,0.453 l-0.018,0.034L12.238,7.53L6.511,6.913L4.777,7.528L4.761,7.531z M12.342,6.932l0.297,0.041l0.146-0.847l-0.359-0.129 L12.342,6.932z M12.898,6.06l0.444,0.159l-0.309-0.942L12.898,6.06z M12.434,3.125l0.57,1.74l0.363-2.082l-0.785-0.212 L12.434,3.125z M11.707,2.232l0.805,0.217l0.1-0.376L11.707,2.232z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BC",
    points: "8.059,7.543 8.047,7.542 5.479,6.881 5.441,6.821 5.503,6.785 8.071,7.445 8.107,7.505  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.885,15.424H2.881l-0.97-0.259l-0.006-0.004l-0.856-0.849l-0.003-0.006l-0.261-0.979V13.32l0.254-0.997 l0.004-0.007l1.02-0.889l0.005-0.003l0.813-0.2l0.012,0.002l0.005,0.01v4.174l-0.005,0.01L2.885,15.424z M1.922,15.141 l0.949,0.254v-4.139l-0.794,0.196l-1.013,0.883l-0.252,0.989l0.258,0.972L1.922,15.141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M1.914,15.166H1.911l-0.009-0.009l-0.293-0.854l-0.137-0.604l-0.691-0.342l-0.008-0.013l0.008-0.012 l0.723-0.343l0.237-0.666l-0.688,0.018l0,0l-0.014-0.013l0.013-0.015l0.699-0.018l0.308-0.861l0.012-0.009l0,0l0.013,0.009 l0.375,0.865l0.431,0.033l0.013,0.011l-0.009,0.015l-0.34,0.162L2.9,13.322l-0.004,0.016l-0.819,0.629l0.787,0.389l0.007,0.008 h0.002l0.01,0.005l-0.002,0.019l-0.957,0.777L1.914,15.166z M1.64,14.309l0.282,0.82l0.924-0.75L1.64,14.309z M1.666,14.283 l1.127,0.066l-0.74-0.365L1.666,14.283z M1.503,13.713l0.128,0.563l0.396-0.305L1.503,13.713z M1.496,13.68l0.555,0.273 l0.82-0.631l-0.342-0.79l-1.004,0.477L1.414,13.32L1.496,13.68z M0.817,13.345l0.647,0.319l-0.078-0.342l0.001-0.008l0.103-0.289 L0.817,13.345z M1.77,12.324l-0.231,0.648l0.98-0.465L2.44,12.326l-0.197-0.016L1.77,12.324z M2.471,12.329l0.072,0.168 l0.293-0.14L2.471,12.329z M2.243,12.285l0.185,0.014l-0.355-0.82L1.78,12.297L2.243,12.285z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.041,
    y: 11.416,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 11.6541 18.0848)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.028,
    y: 12.289,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 10.5418 20.2916)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.853,
    y: 12.311,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 13.6711 19.0384)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.495,
    y: 12.965,
    transform: "matrix(-0.7132 0.7009 -0.7009 -0.7132 11.7448 21.2046)",
    fill: "#1C75BC",
    width: 0.079,
    height: 0.079
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.594,
    y: 14.241,
    transform: "matrix(-0.704 0.7102 -0.7102 -0.704 12.9264 23.1754)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.822,
    y: 15.36,
    transform: "matrix(-0.704 0.7102 -0.7102 -0.704 15.8138 24.2103)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.019,
    y: 14.264,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 11.9214 23.6694)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.837,
    y: 13.264,
    transform: "matrix(-0.7132 0.7009 -0.7009 -0.7132 14.2539 20.7757)",
    fill: "#1C75BC",
    width: 0.079,
    height: 0.079
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.21,
    y: 12.267,
    transform: "matrix(-0.704 0.7102 -0.7102 -0.704 12.5734 19.3733)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.234,
    y: 14.828,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 14.3956 23.7735)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.885,15.461l-0.014-0.002L1.902,15.2l-0.023-0.013l-0.855-0.85l-0.013-0.021L0.75,13.338v-0.025 l0.254-0.996l0.016-0.025l1.019-0.889l0.021-0.01l0.813-0.201L2.915,11.2l0.019,0.039v4.173l-0.02,0.039L2.885,15.461z  M1.94,15.107l0.894,0.238v-4.043l-0.739,0.184l-0.998,0.869l-0.247,0.97l0.254,0.952L1.94,15.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M1.914,15.203L1.9,15.201l-0.033-0.032l-0.293-0.854L1.44,13.723l-0.676-0.334l-0.028-0.045l0.029-0.045 l0.709-0.336l0.215-0.602l-0.636,0.017l0,0L1.002,12.33l0.049-0.053l0.674-0.017l0.299-0.838l0.046-0.032l0,0l0.047,0.029 l0.365,0.846l0.409,0.031l0.046,0.041l-0.028,0.055L2.602,12.54l0.332,0.769l-0.016,0.06l-0.771,0.593l0.734,0.363l0.008,0.005 l0.023,0.016l-0.008,0.07l-0.958,0.776L1.914,15.203z M1.691,14.348l0.248,0.721l0.81-0.657L1.691,14.348z M1.766,14.252 l0.849,0.05l-0.557-0.274L1.766,14.252z M1.556,13.78l0.099,0.433l0.303-0.234L1.556,13.78z M1.527,13.655l0.519,0.256l0.78-0.601 l-0.315-0.729l-0.956,0.454l-0.103,0.287L1.527,13.655z M0.901,13.345l0.511,0.253L1.351,13.33l0.002-0.028l0.073-0.206 L0.901,13.345z M1.796,12.359l-0.194,0.543l0.869-0.412l-0.056-0.129L2.24,12.348L1.796,12.359z M2.527,12.37l0.034,0.078 l0.136-0.064L2.527,12.37z M2.075,11.577l-0.243,0.682l0.41-0.011l0.128,0.01L2.075,11.577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.082,11.563l-0.105-0.105l0.105-0.107l0.107,0.107L2.082,11.563z M2.082,11.45v0.013l0.008-0.006 L2.082,11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M1.068,12.436l-0.107-0.106l0.107-0.106l0.105,0.106L1.068,12.436z M1.068,12.322v0.013l0.006-0.006 L1.068,12.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.893,12.458l-0.107-0.106l0.107-0.106l0.105,0.106L2.893,12.458z M2.893,12.344v0.014l0.006-0.006 L2.893,12.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M1.535,13.111L1.43,13.005l0.105-0.108l0.107,0.108L1.535,13.111z M1.535,12.998v0.014l0.008-0.006 L1.535,12.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M1.634,14.387l-0.106-0.105l0.106-0.107l0.106,0.107L1.634,14.387z M1.634,14.273v0.014l0.007-0.006 L1.634,14.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.862,15.506L2.756,15.4l0.106-0.107L2.969,15.4L2.862,15.506z M2.862,15.393v0.014L2.869,15.4 L2.862,15.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M1.059,14.411l-0.106-0.106l0.106-0.106l0.107,0.106L1.059,14.411z M1.059,14.297v0.014l0.007-0.006 L1.059,14.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.877,13.411L2.77,13.305l0.107-0.107l0.105,0.107L2.877,13.411z M2.877,13.297v0.014l0.006-0.006 L2.877,13.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.25,12.413l-0.105-0.106L2.25,12.2l0.107,0.106L2.25,12.413z M2.25,12.299v0.014l0.008-0.006 L2.25,12.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.274,14.975l-0.106-0.106l0.106-0.107l0.106,0.107L2.274,14.975z M2.274,14.861v0.013l0.007-0.006 L2.274,14.861z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.884,15.424l-0.009-0.003l-0.004-0.01v-4.173l0.004-0.01l0.012-0.004L3.7,11.427l0.006,0.003 l1.019,0.889l0.004,0.007l0.254,0.997v0.007l-0.26,0.979l-0.004,0.006l-0.855,0.849l-0.006,0.004l-0.971,0.259H2.884V15.424z  M2.897,11.256v4.139l0.948-0.254l0.852-0.845l0.259-0.972l-0.253-0.989L3.69,11.453L2.897,11.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M3.854,15.166l-0.009-0.003l-0.958-0.777l-0.002-0.019l0.013-0.006l0.007-0.006l0.787-0.39l-0.819-0.629 L2.868,13.32l0.348-0.801l-0.34-0.16l-0.008-0.016l0.012-0.011L3.311,12.3l0.375-0.866l0.013-0.008l0.012,0.01l0.309,0.86 l0.699,0.019l0.012,0.014l-0.013,0.013H4.715l-0.688-0.018l0.237,0.666l0.723,0.343l0.008,0.012l-0.008,0.014l-0.691,0.341 l-0.137,0.604l-0.293,0.855l-0.009,0.009H3.854z M2.922,14.379l0.925,0.75l0.282-0.82L2.922,14.379z M3.715,13.984l-0.74,0.365 l1.127-0.066L3.715,13.984z M3.741,13.973l0.396,0.303l0.128-0.563L3.741,13.973z M2.896,13.323l0.821,0.631l0.555-0.274 l0.081-0.359L4.242,13.01l-1.004-0.477L2.896,13.323z M4.277,13.025l0.104,0.289v0.009l-0.078,0.342l0.648-0.319L4.277,13.025z  M3.25,12.508l0.98,0.465l-0.232-0.648l-0.475-0.014l-0.195,0.017L3.25,12.508z M2.932,12.357l0.293,0.14l0.073-0.168 L2.932,12.357z M3.695,11.477L3.34,12.298l0.184-0.014l0.465,0.012L3.695,11.477z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.645,
    y: 11.417,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 9.1808 0.7496)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.661,
    y: 12.288,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 10.0941 0.2869)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.837,
    y: 12.312,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 9.5765 1.5834)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.192,
    y: 12.966,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 10.4362 0.8166)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.095,
    y: 14.241,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 11.3091 1.259)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.079
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.866,
    y: 15.36,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 11.7409 2.4556)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.669,
    y: 14.265,
    transform: "matrix(0.704 0.7102 -0.7102 0.704 11.5522 0.8898)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.852,
    y: 13.265,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 10.2549 1.8518)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.477,
    y: 12.267,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 9.7322 1.1176)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.454,
    y: 14.827,
    transform: "matrix(0.704 0.7102 -0.7102 0.704 11.5922 1.9187)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.884,15.461l-0.03-0.011l-0.02-0.039v-4.173l0.02-0.039l0.043-0.01l0.813,0.201l0.021,0.012l1.018,0.888 l0.016,0.024l0.255,0.998l-0.001,0.024l-0.26,0.979l-0.014,0.021l-0.855,0.85L3.868,15.2l-0.97,0.259L2.884,15.461z M2.934,11.303 v4.043l0.895-0.238l0.836-0.83l0.254-0.952l-0.246-0.97l-0.998-0.869L2.934,11.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M3.854,15.203l-0.031-0.012l-0.959-0.777l-0.007-0.07l0.022-0.016l0.009-0.005l0.734-0.363L2.85,13.367 l-0.016-0.061l0.333-0.769l-0.308-0.146l-0.028-0.056l0.046-0.041l0.408-0.03l0.366-0.847l0.046-0.03h0.002l0.045,0.033 l0.299,0.838l0.674,0.018l0.049,0.052l-0.05,0.049H4.715l-0.636-0.017l0.215,0.602l0.709,0.336l0.028,0.045l-0.027,0.045 l-0.676,0.334l-0.133,0.586L3.9,15.168L3.867,15.2L3.854,15.203z M3.019,14.411l0.811,0.657l0.247-0.721L3.019,14.411z  M3.711,14.027l-0.557,0.274l0.848-0.05L3.711,14.027z M3.811,13.979l0.304,0.233l0.099-0.433L3.811,13.979z M2.941,13.311 l0.78,0.601l0.519-0.256l0.076-0.332l-0.104-0.287l-0.955-0.454L2.941,13.311z M4.342,13.096l0.073,0.206l0.001,0.028 l-0.061,0.268l0.512-0.253L4.342,13.096z M3.297,12.49l0.869,0.412l-0.193-0.543l-0.449-0.012l-0.17,0.014L3.297,12.49z  M3.071,12.383l0.136,0.063L3.24,12.37L3.071,12.383z M3.521,12.248l0.415,0.011l-0.243-0.682l-0.294,0.681L3.521,12.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M3.686,11.563L3.58,11.457l0.106-0.107l0.106,0.107L3.686,11.563z M3.686,11.45l-0.007,0.007l0.007,0.006 V11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M4.7,12.436l-0.106-0.106L4.7,12.221l0.106,0.107L4.7,12.436z M4.7,12.322l-0.007,0.007L4.7,12.334V12.322 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.877,12.458L2.77,12.352l0.107-0.107l0.105,0.107L2.877,12.458z M2.877,12.344l-0.008,0.008l0.008,0.006 V12.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M4.232,13.111l-0.106-0.105l0.106-0.107l0.106,0.107L4.232,13.111z M4.232,12.998l-0.007,0.008 l0.007,0.006V12.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M4.135,14.387l-0.107-0.105l0.107-0.107l0.105,0.107L4.135,14.387z M4.135,14.273l-0.008,0.008 l0.008,0.006V14.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.906,15.506L2.799,15.4l0.107-0.107L3.012,15.4L2.906,15.506z M2.906,15.393L2.898,15.4l0.008,0.006 V15.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M4.709,14.411l-0.106-0.106l0.106-0.106l0.107,0.106L4.709,14.411z M4.709,14.297l-0.006,0.008 l0.006,0.006V14.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M2.893,13.411l-0.107-0.106l0.107-0.106l0.105,0.106L2.893,13.411z M2.893,13.297l-0.008,0.008 l0.008,0.006V13.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M3.518,12.413L3.41,12.307l0.107-0.107l0.106,0.107L3.518,12.413z M3.518,12.299l-0.007,0.008l0.007,0.006 V12.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M3.494,14.975l-0.107-0.106l0.107-0.107L3.6,14.868L3.494,14.975z M3.494,14.861l-0.008,0.007l0.008,0.006 V14.861z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.502,15.424H8.5l-0.971-0.259l-0.006-0.004l-0.855-0.849l-0.004-0.006l-0.261-0.979V13.32l0.254-0.997 l0.005-0.007L7.68,11.43l0.006-0.003l0.814-0.2l0.012,0.002l0.004,0.011v4.173l-0.004,0.01L8.502,15.424z M7.54,15.141l0.95,0.254 v-4.139l-0.795,0.196l-1.013,0.883l-0.252,0.99l0.26,0.972L7.54,15.141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M7.533,15.166H7.529l-0.01-0.009l-0.292-0.854L7.09,13.698l-0.691-0.341l-0.007-0.014l0.007-0.012 l0.723-0.343l0.238-0.666l-0.688,0.018H6.67l-0.013-0.013l0.013-0.014l0.699-0.019l0.307-0.86l0.013-0.01H7.69l0.012,0.008 L8.077,12.3l0.432,0.033l0.012,0.011l-0.009,0.016l-0.34,0.162l0.348,0.801l-0.006,0.016l-0.818,0.629l0.787,0.389l0.006,0.008 H8.49l0.012,0.005L8.5,14.385l-0.959,0.777L7.533,15.166z M7.258,14.309l0.281,0.82l0.924-0.75L7.258,14.309z M7.284,14.283 l1.127,0.066l-0.739-0.365L7.284,14.283z M7.121,13.713l0.128,0.563l0.396-0.303L7.121,13.713z M7.113,13.68l0.555,0.273 l0.822-0.631l-0.343-0.79l-1.005,0.477l-0.11,0.312L7.113,13.68z M6.436,13.345l0.647,0.319l-0.077-0.342v-0.008l0.104-0.289 L6.436,13.345z M7.389,12.324l-0.232,0.648l0.98-0.465l-0.078-0.182l-0.197-0.016L7.389,12.324z M8.088,12.329l0.073,0.168 l0.294-0.14L8.088,12.329z M7.861,12.285l0.185,0.014l-0.356-0.82l-0.291,0.818L7.861,12.285z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.661,
    y: 11.416,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 21.2465 14.1115)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.645,
    y: 12.289,
    transform: "matrix(-0.704 0.7102 -0.7102 -0.704 20.1477 16.2616)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.47,
    y: 12.311,
    transform: "matrix(-0.7132 0.7009 -0.7009 -0.7132 23.2361 15.1946)",
    fill: "#1C75BC",
    width: 0.079,
    height: 0.079
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.114,
    y: 12.966,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 21.4088 17.1439)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.212,
    y: 14.241,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 22.4782 19.2517)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.44,
    y: 15.36,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 25.366 20.2939)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.638,
    y: 14.264,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 21.5139 19.6961)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.454,
    y: 13.265,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 23.9074 16.7066)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.829,
    y: 12.267,
    transform: "matrix(-0.704 0.7102 -0.7102 -0.704 22.1486 15.3828)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.853,
    y: 14.827,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 23.987 19.7986)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.502,15.461L8.49,15.459l-0.97-0.258l-0.021-0.014l-0.856-0.849L6.63,14.316l-0.261-0.979l-0.001-0.025 l0.255-0.996l0.016-0.025l1.019-0.889l0.021-0.01l0.813-0.201L8.533,11.2l0.02,0.039v4.173l-0.02,0.039L8.502,15.461z  M7.559,15.107l0.895,0.238v-4.043l-0.74,0.184l-0.998,0.869l-0.247,0.97l0.254,0.952L7.559,15.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M7.533,15.203L7.52,15.201l-0.033-0.032l-0.293-0.854l-0.135-0.59l-0.676-0.334l-0.027-0.046L6.383,13.3 l0.709-0.336l0.215-0.603l-0.635,0.018H6.67L6.621,12.33l0.048-0.053l0.674-0.017l0.3-0.838l0.045-0.032H7.69l0.045,0.029 l0.367,0.846l0.408,0.031l0.045,0.041l-0.027,0.055L8.219,12.54l0.334,0.769l-0.016,0.06l-0.773,0.593l0.734,0.363l0.01,0.005 l0.021,0.016l-0.006,0.07l-0.959,0.776L7.533,15.203z M7.311,14.348l0.246,0.721l0.811-0.657L7.311,14.348z M7.384,14.252 l0.849,0.05l-0.557-0.274L7.384,14.252z M7.174,13.78l0.098,0.433l0.305-0.234L7.174,13.78z M7.146,13.655l0.519,0.256 l0.781-0.601L8.13,12.582l-0.956,0.454L7.07,13.323L7.146,13.655z M6.52,13.345l0.511,0.253L6.97,13.331l0.001-0.028l0.074-0.205 L6.52,13.345z M7.414,12.359l-0.193,0.543L8.09,12.49l-0.057-0.129l-0.176-0.014L7.414,12.359z M8.146,12.37l0.033,0.078 l0.135-0.064L8.146,12.37z M7.693,11.577L7.45,12.258l0.41-0.011l0.128,0.01L7.693,11.577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M7.701,11.563l-0.107-0.105l0.107-0.107l0.105,0.107L7.701,11.563z M7.701,11.45v0.013l0.006-0.006 L7.701,11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M6.686,12.436L6.58,12.329l0.105-0.106l0.107,0.106L6.686,12.436z M6.686,12.322v0.013l0.008-0.006 L6.686,12.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.51,12.458l-0.106-0.106l0.106-0.106l0.107,0.106L8.51,12.458z M8.51,12.344v0.014l0.008-0.006 L8.51,12.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M7.154,13.111l-0.107-0.105l0.107-0.107l0.105,0.107L7.154,13.111z M7.154,12.998v0.014l0.006-0.006 L7.154,12.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M7.252,14.387l-0.107-0.105l0.107-0.107l0.106,0.107L7.252,14.387z M7.252,14.273v0.014l0.006-0.006 L7.252,14.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.48,15.506L8.374,15.4l0.106-0.107L8.588,15.4L8.48,15.506z M8.48,15.393v0.014L8.488,15.4L8.48,15.393z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M6.678,14.411L6.57,14.305l0.107-0.107l0.105,0.107L6.678,14.411z M6.678,14.297v0.014l0.006-0.006 L6.678,14.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.494,13.411l-0.106-0.106l0.106-0.106l0.107,0.106L8.494,13.411z M8.494,13.297v0.014l0.008-0.006 L8.494,13.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M7.869,12.413l-0.107-0.106L7.869,12.2l0.106,0.106L7.869,12.413z M7.869,12.299v0.014l0.006-0.006 L7.869,12.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M7.893,14.975l-0.106-0.106l0.106-0.107l0.106,0.107L7.893,14.975z M7.893,14.861v0.013L7.9,14.868 L7.893,14.861z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.502,15.424l-0.008-0.003l-0.006-0.01v-4.173l0.006-0.01l0.012-0.004l0.813,0.201l0.007,0.004 l1.021,0.887l0.004,0.008l0.254,0.996v0.008l-0.263,0.979l-0.002,0.006l-0.858,0.85l-0.006,0.004l-0.97,0.259L8.502,15.424 L8.502,15.424z M8.516,11.256v4.139l0.949-0.254l0.852-0.845l0.259-0.972l-0.252-0.989l-1.015-0.883L8.516,11.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M9.473,15.166l-0.01-0.003l-0.957-0.777l-0.002-0.019l0.01-0.006h0.002l0.006-0.006l0.787-0.39 L8.49,13.337L8.486,13.32l0.346-0.801l-0.34-0.16l-0.008-0.016l0.014-0.011l0.43-0.033l0.375-0.866l0.014-0.008l0,0l0.013,0.01 l0.308,0.86l0.698,0.019l0.015,0.014l-0.015,0.013l0,0l-0.688-0.018l0.237,0.666l0.724,0.343l0.008,0.012l-0.008,0.014 l-0.691,0.341l-0.137,0.604l-0.293,0.855l-0.01,0.009H9.473z M8.541,14.379l0.924,0.75l0.281-0.82L8.541,14.379z M9.334,13.984 l-0.74,0.365l1.126-0.066L9.334,13.984z M9.359,13.971l0.396,0.305l0.127-0.563L9.359,13.971z M8.516,13.323l0.82,0.631 l0.555-0.274l0.082-0.359L9.861,13.01l-1.003-0.477L8.516,13.323z M9.896,13.025l0.102,0.289L10,13.323l-0.078,0.342l0.646-0.319 L9.896,13.025z M8.867,12.508l0.98,0.465l-0.23-0.648l-0.475-0.014l-0.196,0.017L8.867,12.508z M8.551,12.357l0.293,0.14 l0.072-0.168L8.551,12.357z M9.314,11.477l-0.355,0.821l0.184-0.014l0.465,0.012L9.314,11.477z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.265,
    y: 11.417,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 10.8266 -3.2237)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.278,
    y: 12.288,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 11.7395 -3.6854)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.454,
    y: 12.312,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 11.2218 -2.3886)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.812,
    y: 12.966,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 12.082 -3.1568)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.714,
    y: 14.241,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 12.9552 -2.7142)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.484,
    y: 15.36,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 13.3863 -1.5167)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.288,
    y: 14.265,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 13.14 -3.1133)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.469,
    y: 13.265,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 11.9001 -2.1201)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.097,
    y: 12.267,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 11.3782 -2.8561)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.071,
    y: 14.828,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 13.1817 -2.088)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.079
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.502,15.461L8.473,15.45l-0.02-0.039v-4.173L8.471,11.2l0.043-0.009l0.814,0.201l0.02,0.01l1.021,0.889 l0.016,0.025l0.255,0.996v0.025l-0.263,0.979l-0.013,0.022l-0.854,0.849l-0.022,0.014L8.517,15.46L8.502,15.461z M8.553,11.303 v4.043l0.892-0.238l0.839-0.83l0.254-0.952l-0.248-0.97l-0.998-0.869L8.553,11.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M9.473,15.203l-0.033-0.012l-0.957-0.777l-0.008-0.07l0.023-0.016l0.008-0.005L9.24,13.96l-0.771-0.593 l-0.016-0.061l0.332-0.768l-0.309-0.146l-0.027-0.055l0.045-0.041l0.41-0.031L9.27,11.42l0.047-0.029l0,0l0.047,0.032l0.3,0.838 l0.674,0.017l0.05,0.053l-0.052,0.049h-0.002l-0.635-0.018l0.215,0.603l0.709,0.336l0.028,0.045l-0.028,0.046l-0.677,0.334 l-0.133,0.586L9.52,15.168L9.486,15.2L9.473,15.203z M8.637,14.411l0.811,0.657l0.247-0.721L8.637,14.411z M9.328,14.027 l-0.557,0.274l0.85-0.05L9.328,14.027z M9.43,13.979l0.303,0.233L9.83,13.78L9.43,13.979z M8.561,13.311l0.779,0.601l0.52-0.256 l0.074-0.332l-0.102-0.287l-0.957-0.454L8.561,13.311z M9.959,13.096l0.074,0.206l0.002,0.028l-0.061,0.268l0.51-0.253 L9.959,13.096z M8.916,12.49l0.869,0.412L9.59,12.359l-0.449-0.012l-0.169,0.014L8.916,12.49z M8.689,12.383l0.135,0.064 l0.035-0.078L8.689,12.383z M9.139,12.248l0.416,0.011l-0.244-0.682l-0.295,0.681L9.139,12.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M9.305,11.563l-0.106-0.105l0.106-0.107l0.105,0.107L9.305,11.563z M9.305,11.45l-0.008,0.007l0.008,0.006 V11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M10.318,12.436l-0.105-0.106l0.105-0.106l0.106,0.106L10.318,12.436z M10.318,12.322l-0.006,0.007 l0.006,0.006V12.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.494,12.458l-0.106-0.106l0.106-0.106l0.107,0.106L8.494,12.458z M8.494,12.344l-0.006,0.008 l0.006,0.006V12.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M9.852,13.111l-0.106-0.105l0.106-0.107l0.105,0.107L9.852,13.111z M9.852,12.998l-0.008,0.008 l0.008,0.006V12.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M9.754,14.387l-0.107-0.105l0.107-0.107l0.105,0.107L9.754,14.387z M9.754,14.273l-0.008,0.008 l0.008,0.006V14.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.523,15.506L8.418,15.4l0.105-0.107L8.631,15.4L8.523,15.506z M8.523,15.393L8.518,15.4l0.006,0.006 L8.523,15.393L8.523,15.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M10.328,14.411l-0.107-0.106l0.107-0.106l0.105,0.106L10.328,14.411z M10.328,14.297l-0.008,0.008 l0.008,0.006V14.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M8.51,13.411l-0.106-0.106l0.106-0.106l0.107,0.106L8.51,13.411z M8.51,13.297l-0.006,0.008l0.006,0.006 V13.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M9.137,12.413l-0.107-0.106L9.137,12.2l0.105,0.106L9.137,12.413z M9.137,12.299l-0.008,0.008l0.008,0.006 V12.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M9.111,14.975l-0.105-0.106l0.105-0.107l0.106,0.107L9.111,14.975z M9.111,14.861l-0.006,0.007 l0.006,0.006V14.861z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.121,15.424h-0.004l-0.969-0.259l-0.006-0.004l-0.857-0.849l-0.002-0.006l-0.262-0.979V13.32 l0.254-0.997l0.004-0.007l1.02-0.889l0.006-0.003l0.813-0.2l0.012,0.002l0.007,0.01v4.174l-0.007,0.01L14.121,15.424z  M13.158,15.141l0.949,0.254v-4.139l-0.793,0.196L12.3,12.335l-0.252,0.989l0.259,0.972L13.158,15.141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M13.152,15.166h-0.004l-0.01-0.009l-0.293-0.854l-0.138-0.604l-0.69-0.342l-0.009-0.013l0.009-0.012 l0.723-0.343l0.238-0.666l-0.689,0.018l0,0l-0.014-0.013l0.014-0.015l0.699-0.018l0.307-0.861l0.012-0.009l0.014,0.009 l0.375,0.865l0.431,0.033l0.015,0.011l-0.009,0.015l-0.34,0.162l0.347,0.801l-0.005,0.016l-0.817,0.629l0.787,0.389l0.006,0.008 h0.002l0.01,0.005l-0.002,0.019l-0.957,0.777L13.152,15.166z M12.877,14.309l0.281,0.82l0.924-0.75L12.877,14.309z M12.902,14.283 l1.127,0.066l-0.738-0.365L12.902,14.283z M12.74,13.713l0.127,0.563l0.396-0.303L12.74,13.713z M12.732,13.68l0.555,0.273 l0.82-0.631l-0.342-0.79l-1.004,0.477L12.65,13.32L12.732,13.68z M12.055,13.345l0.646,0.319l-0.078-0.342l0.002-0.008 l0.102-0.289L12.055,13.345z M13.006,12.324l-0.23,0.648l0.98-0.465l-0.08-0.182l-0.197-0.016L13.006,12.324z M13.707,12.329 l0.072,0.168l0.295-0.14L13.707,12.329z M13.48,12.285l0.184,0.014l-0.355-0.82l-0.293,0.818L13.48,12.285z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.278,
    y: 11.417,
    transform: "matrix(-0.7009 0.7132 -0.7132 -0.7009 30.8243 9.9889)",
    fill: "#1C75BC",
    width: 0.079,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.265,
    y: 12.288,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 29.7227 12.3447)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.089,
    y: 12.312,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 32.8534 11.0948)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.732,
    y: 12.966,
    transform: "matrix(-0.725 0.6887 -0.6887 -0.725 30.9891 13.6376)",
    fill: "#1C75BC",
    width: 0.081,
    height: 0.079
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.831,
    y: 14.241,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 32.0707 15.2784)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.06,
    y: 15.36,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 34.9593 16.3202)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.255,
    y: 14.265,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 31.1037 15.7258)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.073,
    y: 13.265,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 33.5007 12.7329)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.448,
    y: 12.267,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 31.728 11.4711)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.472,
    y: 14.827,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 33.5786 15.8256)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.121,15.461l-0.014-0.002L13.139,15.2l-0.021-0.013l-0.857-0.85l-0.012-0.021l-0.262-0.979v-0.024 l0.254-0.998l0.016-0.024l1.02-0.888l0.021-0.012l0.813-0.201l0.043,0.01l0.019,0.039v4.173L14.15,15.45L14.121,15.461z  M13.178,15.107l0.893,0.238v-4.043l-0.737,0.184l-0.998,0.869l-0.248,0.97l0.254,0.952L13.178,15.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M13.152,15.203l-0.014-0.002l-0.035-0.032l-0.293-0.854l-0.134-0.59l-0.676-0.334l-0.028-0.046 l0.028-0.045l0.709-0.336l0.215-0.603l-0.635,0.018h-0.002l-0.052-0.049l0.05-0.053l0.674-0.017l0.299-0.838l0.048-0.032h0.002 l0.045,0.029l0.367,0.846l0.407,0.031l0.045,0.041l-0.026,0.055l-0.31,0.146l0.332,0.768l-0.017,0.061l-0.771,0.593l0.734,0.363 l0.008,0.005l0.022,0.016l-0.008,0.07l-0.957,0.777L13.152,15.203z M12.928,14.348l0.248,0.721l0.811-0.657L12.928,14.348z  M13.002,14.252l0.85,0.05l-0.557-0.274L13.002,14.252z M12.793,13.78l0.098,0.433l0.305-0.234L12.793,13.78z M12.764,13.655 l0.521,0.256l0.778-0.601l-0.313-0.729l-0.957,0.454l-0.103,0.287L12.764,13.655z M12.139,13.345l0.51,0.253l-0.061-0.268 l0.002-0.028l0.074-0.206L12.139,13.345z M13.033,12.359l-0.195,0.543l0.869-0.412l-0.055-0.129l-0.176-0.014L13.033,12.359z  M13.766,12.37l0.033,0.077l0.135-0.063L13.766,12.37z M13.313,11.577l-0.244,0.682l0.41-0.011l0.129,0.01L13.313,11.577z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M13.318,11.563l-0.105-0.105l0.105-0.107l0.106,0.107L13.318,11.563z M13.318,11.45v0.013l0.008-0.006 L13.318,11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M12.305,12.436l-0.106-0.106l0.106-0.106l0.107,0.106L12.305,12.436z M12.305,12.322v0.013l0.006-0.006 L12.305,12.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.129,12.458l-0.107-0.106l0.107-0.106l0.105,0.106L14.129,12.458z M14.129,12.344v0.014l0.006-0.006 L14.129,12.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M12.771,13.111l-0.105-0.105l0.105-0.107l0.106,0.107L12.771,13.111z M12.771,12.998v0.014l0.008-0.006 L12.771,12.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M12.871,14.387l-0.107-0.105l0.107-0.107l0.105,0.107L12.871,14.387z M12.871,14.273v0.014l0.006-0.006 L12.871,14.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.1,15.506L13.992,15.4l0.107-0.107l0.104,0.107L14.1,15.506z M14.1,15.393v0.014l0.006-0.006 L14.1,15.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M12.295,14.411l-0.105-0.106l0.105-0.106l0.107,0.106L12.295,14.411z M12.295,14.297v0.014l0.008-0.006 L12.295,14.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.113,13.411l-0.107-0.106l0.107-0.106l0.104,0.106L14.113,13.411z M14.113,13.297v0.014l0.006-0.006 L14.113,13.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M13.488,12.413l-0.107-0.106l0.107-0.106l0.104,0.106L13.488,12.413z M13.488,12.299v0.014l0.006-0.006 L13.488,12.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M13.512,14.975l-0.107-0.106l0.107-0.107l0.105,0.107L13.512,14.975z M13.512,14.861v0.013l0.006-0.006 L13.512,14.861z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.121,15.424l-0.008-0.003l-0.006-0.01v-4.173l0.006-0.01l0.01-0.004l0.814,0.201l0.006,0.004 l1.018,0.887l0.004,0.008l0.254,0.996v0.008l-0.26,0.979l-0.004,0.006l-0.855,0.85l-0.006,0.004l-0.969,0.259L14.121,15.424 L14.121,15.424z M14.135,11.256v4.139l0.947-0.254l0.852-0.845l0.26-0.972l-0.254-0.989l-1.012-0.883L14.135,11.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M15.09,15.166l-0.008-0.003l-0.959-0.777l-0.002-0.019l0.014-0.006l0.006-0.006l0.787-0.39l-0.818-0.629 l-0.006-0.017l0.818-1.887l0.012-0.008l0,0l0.015,0.01l0.67,1.879v0.008l-0.076,0.342l0.672-0.332l0.019,0.006l-0.006,0.02 l-0.691,0.341l-0.137,0.604l-0.293,0.855l-0.01,0.009H15.09z M14.16,14.379l0.924,0.75l0.281-0.82L14.16,14.379z M14.951,13.984 l-0.738,0.365l1.127-0.066L14.951,13.984z M14.979,13.973l0.396,0.303l0.127-0.563L14.979,13.973z M14.133,13.323l0.822,0.631 l0.555-0.272l0.08-0.361l-0.656-1.842L14.133,13.323z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BC",
    points: "14.117,12.361 14.104,12.35 14.115,12.334 14.76,12.285 15.953,12.314 15.965,12.329  15.953,12.341 15.951,12.341 14.76,12.311  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.882,
    y: 11.417,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 12.4719 -7.1957)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.898,
    y: 12.289,
    transform: "matrix(0.7009 0.7132 -0.7132 0.7009 13.5599 -7.6798)",
    fill: "#1C75BC",
    width: 0.079,
    height: 0.079
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.073,
    y: 12.312,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 12.8676 -6.3619)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.429,
    y: 12.966,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 13.7272 -7.1287)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.331,
    y: 14.241,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 14.6005 -6.6861)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.103,
    y: 15.36,
    transform: "matrix(0.7132 0.7009 -0.7009 0.7132 14.85 -5.4967)",
    fill: "#1C75BC",
    width: 0.079,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.905,
    y: 14.265,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 14.7852 -7.0853)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.089,
    y: 13.265,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 13.5461 -6.0938)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.714,
    y: 12.267,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 13.0234 -6.8281)",
    fill: "#1C75BC",
    width: 0.08,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.691,
    y: 14.828,
    transform: "matrix(0.7132 0.7009 -0.7009 0.7132 14.6455 -6.0614)",
    fill: "#1C75BC",
    width: 0.079,
    height: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.121,15.461L14.09,15.45l-0.02-0.039v-4.173l0.02-0.039l0.043-0.01l0.813,0.201l0.021,0.012 l1.018,0.888L16,12.316l0.256,0.996l-0.002,0.025l-0.26,0.979l-0.014,0.022l-0.855,0.849l-0.021,0.014l-0.971,0.259L14.121,15.461 z M14.17,11.303v4.043l0.895-0.238l0.836-0.83l0.254-0.952l-0.245-0.97l-0.998-0.869L14.17,11.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M15.09,15.203l-0.031-0.012L14.1,14.414l-0.006-0.07l0.021-0.016l0.01-0.005l0.734-0.363l-0.773-0.593 l-0.016-0.061l0.818-1.887l0.045-0.029h0.002l0.045,0.032l0.672,1.879v0.028l-0.062,0.268l0.604-0.298l0.068,0.022l-0.023,0.066 l-0.676,0.334l-0.133,0.586l-0.295,0.858l-0.033,0.032L15.09,15.203z M14.256,14.411l0.811,0.657l0.246-0.721L14.256,14.411z  M14.947,14.027l-0.557,0.274l0.848-0.05L14.947,14.027z M15.047,13.979l0.305,0.233l0.099-0.433L15.047,13.979z M14.178,13.311 l0.781,0.601l0.518-0.256l0.076-0.332l-0.623-1.746L14.178,13.311z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BC",
    points: "14.117,12.398 14.066,12.352 14.113,12.297 14.758,12.248 15.953,12.277 16.002,12.33  15.953,12.378 15.951,12.378 14.76,12.348 14.121,12.398  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.922,11.563l-0.105-0.105l0.105-0.107l0.107,0.107L14.922,11.563z M14.922,11.45l-0.006,0.007 l0.006,0.006V11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M15.938,12.436l-0.106-0.106l0.106-0.106l0.105,0.106L15.938,12.436z M15.938,12.322l-0.008,0.007 l0.008,0.006V12.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.113,12.458l-0.107-0.106l0.107-0.106l0.104,0.106L14.113,12.458z M14.113,12.344l-0.008,0.008 l0.008,0.006V12.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M15.469,13.111l-0.105-0.105l0.105-0.107l0.107,0.107L15.469,13.111z M15.469,12.998l-0.006,0.008 l0.006,0.006V12.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M15.371,14.387l-0.107-0.105l0.107-0.107l0.107,0.107L15.371,14.387z M15.371,14.273l-0.006,0.008 l0.006,0.006V14.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.143,15.506L14.035,15.4l0.107-0.107l0.104,0.107L14.143,15.506z M14.143,15.393L14.135,15.4 l0.008,0.006V15.393z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M15.945,14.411l-0.105-0.106l0.105-0.106l0.106,0.106L15.945,14.411z M15.945,14.297l-0.006,0.008 l0.006,0.006V14.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.129,13.411l-0.107-0.106l0.107-0.106l0.105,0.106L14.129,13.411z M14.129,13.297l-0.008,0.008 l0.008,0.006V13.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.754,12.413l-0.105-0.106l0.105-0.106l0.107,0.106L14.754,12.413z M14.754,12.299l-0.006,0.008 l0.006,0.006V12.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.73,14.975l-0.107-0.106l0.107-0.107l0.106,0.107L14.73,14.975z M14.73,14.861l-0.008,0.007 l0.008,0.006V14.861z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BC",
    points: "2.895,11.29 2.846,11.24 2.846,9.245 2.895,9.193 8.58,9.193 8.617,9.209 8.631,9.247  8.553,11.241 8.502,11.29 8.5,11.29 8.453,11.236 8.529,9.294 2.945,9.294 2.945,11.24  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M13.375,11.506l-0.025-0.008l-0.018-0.068l0.484-0.811L13.725,10.4l-0.002-0.034l0.084-0.267l-1.175-0.807 H8.58L8.531,9.244V8.972L7.299,9.07L6.912,9.288L6.883,9.293L5.895,9.182L4.467,9.294L4.415,9.258L4.439,9.2l0.246-0.132 L2.962,9.286l0.409,1.229l-0.008,0.045l-0.428,0.584l-0.07,0.012l-0.01-0.07l0.412-0.563L2.848,9.26l0.006-0.043l0.035-0.021 l5.138-0.651l0.031-0.018l0.478-1.054l0.057-0.028l0.039,0.049v0.994l5.507,0.708l0.045,0.049v1.996l-0.039,0.049l-0.058-0.03 l-0.224-0.524l-0.444,0.748L13.375,11.506z M13.928,10.626l0.154,0.366v-0.625L13.928,10.626z M13.822,10.379l0.057,0.133 l0.152-0.256l-0.139-0.097L13.822,10.379z M13.924,10.061l0.158,0.107V9.566L13.924,10.061z M12.809,9.294l1.029,0.707 l0.227-0.707H12.809z M12.664,9.193h0.686l-0.844-0.107L12.664,9.193z M11.805,9.193h0.682l-0.172-0.117L11.805,9.193z  M8.631,9.193h2.672L10.326,8.83L8.631,8.964V9.193z M6.414,9.141l0.463,0.053l0.185-0.104L6.414,9.141z M4.896,9.066L4.695,9.175 l0.68-0.054L4.896,9.066z M10.664,8.849l0.838,0.313l0.57-0.132L10.664,8.849z M5.206,9.001l0.69,0.079l1.371-0.108l0.529-0.299 L5.206,9.001z M8.059,8.64L7.504,8.954l1.027-0.082V8.581L8.059,8.64z M8.631,8.588v0.275l1.33-0.105L8.631,8.588z M8.531,7.724 L8.168,8.526L8.531,8.48V7.724z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M7.701,11.506L7.678,11.5l-0.021-0.066l0.713-1.408L7.906,9.27V9.219l0.043-0.025h1.244L9.24,9.229 L9.223,9.284L8.621,9.751l-0.137,0.271l0.862,1.408L9.33,11.499l-0.068-0.017l-0.831-1.356L7.745,11.48L7.701,11.506z  M8.039,9.294L8.422,9.92l0.115-0.225l0.014-0.018l0.496-0.385L8.039,9.294L8.039,9.294z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BC",
    points: "3.686,11.506 3.639,11.475 3.301,10.611 2.112,11.497 2.053,11.497 2.035,11.439 2.848,9.227  2.912,9.197 2.942,9.261 2.188,11.316 3.293,10.491 3.337,10.482 3.369,10.514 3.732,11.438 3.703,11.502  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M14.922,11.506l-0.041-0.021l-0.822-1.215l-0.008-0.045l0.031-0.031l0.359-0.125l-0.355-0.805l0.025-0.064 l0.065,0.025l0.378,0.854v0.04l-0.007,0.01l0.423,1.313l-0.027,0.061L14.922,11.506z M14.178,10.268l0.59,0.873l-0.311-0.972 L14.178,10.268z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1C75BC",
    points: "11.477,2.272 11.469,2.271 8.447,1.677 7.676,2.249 7.636,2.257 4.718,1.649 4.68,1.589  4.729,1.549 4.738,1.55 7.635,2.155 8.405,1.583 8.445,1.575 11.465,2.168 12.246,1.56 12.316,1.569 12.307,1.639 11.508,2.261  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "M11.451,6.909l-0.006-0.001L9.943,6.704L8.508,6.882L8.502,6.883L8.461,6.86L8.254,6.542L5.56,6.908 L5.553,6.909l-0.04-0.021L5.508,6.837L5.82,6.142L4.617,5.978L4.574,5.934l0.032-0.053l1.59-0.574L6.47,4.699L4.607,4.094 L4.574,4.042l0.043-0.045l1.854-0.221L5.969,2.999L4.63,3.175L4.623,3.176L4.574,3.132l0.043-0.056l1.292-0.171L5.484,2.249 L5.5,2.179l0.069,0.016l0.449,0.696l1.345-0.177L7.6,2.187l0.04-0.028l0.045,0.018l0.366,0.447l3.42-0.451l0.055,0.037l0.23,0.94 l0.619-0.073l0.055,0.038l-0.031,0.059l-0.586,0.211l0.617,2.532l-0.006,0.04l-0.035,0.021l-1.162,0.158l0.689,0.225l0.035,0.052 l-0.043,0.045L11.256,6.54l0.234,0.287l0.006,0.057L11.451,6.909z M5.924,6.156l-0.288,0.64l2.496-0.34L5.924,6.156z M10.33,6.655 l1.002,0.137l-0.193-0.237L10.33,6.655z M8.363,6.526L8.527,6.78l1.03-0.129L8.502,6.507L8.363,6.526z M8.873,6.457l1.07,0.146 l1.119-0.141L10.84,6.189L8.873,6.457z M10.955,6.173l0.225,0.274l0.492-0.063l-0.674-0.219L10.955,6.173z M8.266,6.375 l0.236,0.032l2.264-0.309L10.758,6.09L7.374,4.992L8.266,6.375z M5.967,6.061l2.168,0.295l-0.86-1.332L6.27,5.387L5.967,6.061z  M10.816,6.003l0.19,0.062l1.313-0.179l-0.603-2.468L9.391,4.26L10.816,6.003z M4.832,5.907l1.031,0.141l0.275-0.613L4.832,5.907z  M7.521,4.935l3.12,1.012L9.29,4.297L7.521,4.935z M6.566,4.73L6.327,5.26l0.886-0.32L6.566,4.73z M7.288,4.859l0.079,0.025 l1.855-0.67L8.729,3.61L6.977,3.818L6.828,4.146L7.288,4.859z M6.607,4.638l0.53,0.172L6.779,4.255L6.607,4.638z M4.855,4.07 l1.656,0.537l0.203-0.452L6.531,3.871L4.855,4.07z M8.846,3.596l0.477,0.582l2.37-0.857L11.68,3.259L8.846,3.596z M6.643,3.858 l0.121,0.188L6.86,3.832L6.643,3.858z M6.078,2.985l0.504,0.779l0.326-0.039l0.406-0.904L6.078,2.985z M7.432,2.806L7.023,3.711 l1.631-0.193L8.008,2.73L7.432,2.806z M8.125,2.714l0.646,0.79l2.885-0.343l-0.217-0.885L8.125,2.714z M11.779,3.248l0.01,0.039 l0.166-0.06L11.779,3.248z M7.658,2.302L7.48,2.699l0.453-0.06L7.658,2.302z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.627,
    y: 1.499,
    transform: "matrix(-0.7047 0.7095 -0.7095 -0.7047 9.1957 -0.6267)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.203
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.137,
    y: 1.5,
    transform: "matrix(-0.7047 0.7095 -0.7095 -0.7047 21.9981 -5.9548)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.686,
    y: 5.933,
    transform: "matrix(-0.7059 0.7083 -0.7083 -0.7059 22.6751 2.6514)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.201
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.48,
    y: 6.182,
    transform: "matrix(-0.7095 0.7047 -0.7047 -0.7095 10.5496 8.2168)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.422,
    y: 2.121,
    transform: "matrix(-0.7083 0.7059 -0.7059 -0.7083 21.2557 -4.3395)",
    fill: "#1C75BC",
    width: 0.204,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.323,
    y: 6.182,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 27.3585 1.2332)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.958,
    y: 7.392,
    transform: "matrix(-0.7095 0.7047 -0.7047 -0.7095 19.0581 7.1295)",
    fill: "#1C75BC",
    width: 0.204,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.847,
    y: 9.177,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 11.5932 13.7555)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.203
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.957,
    y: 12.25,
    transform: "matrix(-0.7047 0.7095 -0.7095 -0.7047 10.5686 20.3025)",
    fill: "#1C75BC",
    width: 0.204,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.608,
    y: 14.203,
    transform: "matrix(-0.7083 0.7059 -0.7059 -0.7083 18.1421 21.1118)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.532,
    y: 14.146,
    transform: "matrix(-0.7095 0.7047 -0.7047 -0.7095 12.832 23.2036)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.393,
    y: 12.25,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 23.2359 15.0785)",
    fill: "#1C75BC",
    width: 0.204,
    height: 0.203
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.363,
    y: 15.299,
    transform: "matrix(-0.7083 0.7059 -0.7059 -0.7083 25.3331 20.3315)",
    fill: "#1C75BC",
    width: 0.205,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.542,
    y: 11.355,
    transform: "matrix(-0.7083 0.7059 -0.7059 -0.7083 21.144 14.1752)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.167,
    y: 12.196,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 34.7613 10.1981)",
    fill: "#1C75BC",
    width: 0.203,
    height: 0.204
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.769,
    y: 14.203,
    transform: "matrix(-0.7047 0.7095 -0.7095 -0.7047 32.089 15.2535)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.204
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.027,
    y: 11.138,
    transform: "matrix(-0.7047 0.7095 -0.7095 -0.7047 32.0589 9.1371)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.204
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.409,
    y: 9.944,
    transform: "matrix(-0.7095 0.7047 -0.7047 -0.7095 31.8848 6.946)",
    fill: "#1C75BC",
    width: 0.204,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.29,
    y: 8.945,
    transform: "matrix(-0.7095 0.7047 -0.7047 -0.7095 27.5581 6.7315)",
    fill: "#1C75BC",
    width: 0.204,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.808,
    y: 8.89,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 14.7382 11.8776)",
    fill: "#1C75BC",
    width: 0.203,
    height: 0.203
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.465,
    y: 7.392,
    transform: "matrix(-0.7083 0.7059 -0.7059 -0.7083 19.925 6.7524)",
    fill: "#1C75BC",
    width: 0.204,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.466,
    y: 9.601,
    transform: "matrix(-0.7119 0.7023 -0.7023 -0.7119 21.4806 10.5912)",
    fill: "#1C75BC",
    width: 0.203,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.237,
    y: 4.852,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 16.0301 3.2673)",
    fill: "#1C75BC",
    width: 0.203,
    height: 0.203
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.524,
    y: 2.121,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 14.5884 -1.5984)",
    fill: "#1C75BC",
    width: 0.203,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.963,
    y: 4.125,
    transform: "matrix(-0.7059 0.7083 -0.7083 -0.7059 9.9269 4.3313)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.203
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.452,
    y: 6.733,
    transform: "matrix(-0.7083 0.7059 -0.7059 -0.7083 14.3112 7.7544)",
    fill: "#1C75BC",
    width: 0.202,
    height: 0.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.221,
    y: 3.01,
    transform: "matrix(-0.7095 0.7047 -0.7047 -0.7095 23.259 -3.3659)",
    fill: "#1C75BC",
    width: 0.204,
    height: 0.202
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.70d740aec397a05e7f0b46f20ff88801.svg";
export { ForwardRef as ReactComponent };